import { actionTypes } from "./registerConstants";

const {
   REGISTER_START,
  UPDATE_REG_USERNAME,
  UPDATE_REG_PASSWORD,
  UPDATE_CONFIRM_USERNAME,
  UPDATE_CONFIRM_PASSWORD,
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  REGISTER_COMPLETE,
  SET_SHOW_ERROR
} = actionTypes;

const INITIAL_STATE = {
  username: '',
  password: '',
  confirmUsername: '',
  confirmPassword: '',
  isLoading: false,
  isRegisterationComplete: false,
  showError: false,
  errorText: ''
}

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REGISTER_START:
      return Object.assign({}, state, { isLoading: true });

    case UPDATE_REG_USERNAME:
      return Object.assign({}, state, { username: action.payload.username });

    case UPDATE_REG_PASSWORD:
      return Object.assign({}, state, { password: action.payload.password });

    case UPDATE_CONFIRM_USERNAME:
      return Object.assign({}, state, { confirmUsername: action.payload.confirmUsername })

    case UPDATE_CONFIRM_PASSWORD:
      return Object.assign({}, state, { confirmPassword: action.payload.confirmPassword })

    case REGISTER_SUCCESS:
      return Object.assign({}, state, { isLoading: true, password: '', username: '', confirmUsername: '', confirmPassword: '' });

    case REGISTER_COMPLETE:
      return Object.assign({}, state, { isLoading: false, isRegisterationComplete: action.payload.isCompleted, password: '', username: '', confirmUsername: '', confirmPassword: '' })

    case REGISTER_FAILED:
      return Object.assign({}, state, { isLoading: false, showError: true, errorText: action.payload.errorText, isRegisterationComplete: false })

    case SET_SHOW_ERROR:
      return Object.assign({}, state, { showError: action.payload });
    default:
      return state;
  }
};

export default reducer;
